// extracted by mini-css-extract-plugin
export var emptyState = "_4x-d";
export var statCard = "_4x-c";
export var table = "_4x-0";
export var tableCell = "_4x-4";
export var tableCellClickable = "_4x-5 _4x-4";
export var tableCellDefault = "_4x-6 _4x-4";
export var tableCellEmpty = "_4x-8";
export var tableCellWithValue = "_4x-7";
export var tableContainer = "_4x-e";
export var tableHeaderWeight = "_4x-1";
export var tableHeaderZone = "_4x-2";
export var tableRowHeader = "_4x-3";
export var viewModeButton = "_4x-9";
export var viewModeButtonActive = "_4x-a _4x-9";
export var viewModeButtonInactive = "_4x-b _4x-9";